module.exports = __webpack_public_path__ + "img/6s.a19f16cf.png";